import { ComponentElem } from "@components/interfaces";
import PopupBase from "./PopupBase";
import Utility from "@ts/sframe/Utility";
import LoginProxy from "@ts/LoginProxy";
import LoginByEmail from "./LoginByEmail";


export default class Login extends PopupBase
{
  constructor(elem: ComponentElem)
  {
    super(elem);

    this.$root.find(`[data-target="line"]`).on("click", (event:Event)=>
    {
      event.preventDefault();
      // LoginProxy.loginByLine();
      LoginProxy.loginBy("line");
    });

    this.$root.find(`[data-target="facebook"]`).on("click", (event:Event)=>
    {
      event.preventDefault();
      LoginProxy.loginBy("facebook");
    });

    this.$root.find(`[data-target="google"]`).on("click", (event:Event)=>
    {
      event.preventDefault();
      LoginProxy.loginBy("google");
    });

    this.$root.find(`[data-target="email"]`).on("click", (event:JQuery.ClickEvent)=>
    {
      event.preventDefault();
      LoginByEmail.instance.toMe();
    });
    
  }
}